import React from 'react';
const EmptyHeader = () => (
    <div className="pageHeader">
        <h3>
            ‎ 
        </h3>
    </div>
);
export default EmptyHeader;